import { fetchFoodOutList } from '@/service/kitchen';
import type { FoodOutDetailsListModel } from '@/model/kitchen';

/** 查询指定餐厅的厨房菜品，避免无厨房参数的全公司查询。 */
export const fetchRestaurantKitchenFoods = async (
  shopId: number,
  kitchenIds: number[],
): Promise<FoodOutDetailsListModel[]> => {
  if (!kitchenIds.length) return [];

  const response = await fetchFoodOutList({
    pageNum: 1,
    pageSize: 999,
    data: { kitchenIds },
  });
  if (response.code !== 200) throw new Error(response.msg || '加载厨房菜品失败');

  const details = new Map<number, FoodOutDetailsListModel>();
  for (const food of response.result?.list || []) {
    for (const detail of food.detailsList || []) {
      if (Number(detail.shopId) === shopId && kitchenIds.includes(Number(detail.kitchenId))) {
        details.set(detail.orderOutId, detail);
      }
    }
  }
  return [...details.values()];
};
